export enum DependencyEnums {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}

export const dependencyTypeOptions = Object.values(DependencyEnums).map(
  (value) => ({
    label: value,
    value,
  }),
);
